export type SortMode = 'default' | 'change_desc' | 'change_asc' | 'spread_asc' | 'agent_first' | 'position_first';

export const SORT_OPTIONS: { key: SortMode; label: string; icon: string }[] = [
  { key: 'default', label: '默认排序', icon: 'ri-sort-desc' },
  { key: 'change_desc', label: '涨幅从高到低', icon: 'ri-arrow-up-line' },
  { key: 'change_asc', label: '跌幅从高到低', icon: 'ri-arrow-down-line' },
  { key: 'spread_asc', label: '点差从低到高', icon: 'ri-exchange-dollar-line' },
  { key: 'agent_first', label: 'AI 智能体优先', icon: 'ri-robot-2-line' },
  { key: 'position_first', label: '有持仓优先', icon: 'ri-briefcase-5-line' },
];

export const SORT_LABEL_MAP: Record<SortMode, string> = {
  default: '默认排序',
  change_desc: '涨幅优先',
  change_asc: '跌幅优先',
  spread_asc: '点差优先',
  agent_first: '智能体优先',
  position_first: '持仓优先',
};

interface SortMenuProps {
  value: SortMode;
  onChange: (mode: SortMode) => void;
  onClose: () => void;
}

export default function SortMenu({ value, onChange, onClose }: SortMenuProps) {
  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 z-40" onClick={onClose} />

      {/* Menu */}
      <div
        className="absolute right-5 top-full mt-2 z-50 bg-white rounded-2xl py-2 w-48"
        style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.12)' }}
      >
        {SORT_OPTIONS.map((opt) => {
          const isActive = value === opt.key;
          return (
            <button
              key={opt.key}
              onClick={() => { onChange(opt.key); onClose(); }}
              className="w-full flex items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors active:bg-gray-50"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i
                  className={`${opt.icon} text-sm`}
                  style={{ color: isActive ? '#6366F1' : '#94A3B8' }}
                />
              </div>
              <span
                className="flex-1"
                style={{ color: isActive ? '#6366F1' : '#374151', fontWeight: isActive ? 600 : 400 }}
              >
                {opt.label}
              </span>
              {isActive && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line text-indigo-500 text-sm" />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </>
  );
}